import slugify from "slugify";

/**
 * Realiza o enconding (slug) de um valor e adiciona uma hash
 * @param {String} value
 * @returns
 */
export function EncodePath(value) {
	return `#${slugify(value, {
		lower: true,
		trim: true,
	})}`;
}

/**
 * Recebe um valor e recupera o id equivalente de um array
 * @param {*} value
 */
export function DecodePathAndReturnId(options, value) {
	let index = 0;
	for (let option of options) {
		if (EncodePath(option) === value) return index;
		index++;
	}
}

/**
 * Valida que o hash fornecido está entre os limites, caso contrário, default para zero.
 * @param {*} amount
 * @param {*} index
 * @returns
 */
export function ValidateHashPath(amount, index) {
	if (index === undefined || index === null) return;

	let indexInt = Number.parseInt(index.toString().replace("#", ""));
	if (isNaN(indexInt)) return 0;
	return indexInt <= amount ? indexInt : 0;
}
